import React, { Component } from "react";
import { Icon, InputNumber, Table, message, Button } from "antd";
import SideNav from '../SideNav';
import "../css/style.less";
import ExportUtil from "../../../common/ExportUtil";
import API_URL from "../../../common/url";
import $ from '../../../common/AjaxRequest';
import dictCache from '../../../common/dictCache';
import ExportCureData from "./ExportCureData";
import Filter from "./Filter";
import CalculateModal from "./CalculateModal";
import SettingModal from "./SettingModal";

class StandardVisitPrice extends Component {
    state = {
        refreshTime: '',
        data: [],
        oldData: [],
        loading: false,
        refreshLoading: false,
        searchParams: {},
        pagination: {
            pageSize: 10,
            current: 1,
        },
        businessList: [],
        areaList: [],
        versionList: [],
        windowList: [],
        researchProductTypeList: [],
    }

    componentDidMount() {
        this.queryNewestDate();
        this.queryBusiness();
        this.loadTypeConfigureList();
        this.queryConfigWithChildByType();
        this.initSearchParams();
    }

    resetData = () => {
        this.setState({ pagination: {
            pageSize: 10,
            current: 1,
        }}, () => {
            this.queryNewestDate();
            this.initSearchParams();
        });
    }
    //  计算基础版本&参数修改时间 下拉数据
    queryHavCalculateVersionList = () => {
        return new Promise((resolve) => {
            const options = {
                method: 'POST',
                url: API_URL.evaluate.queryHavCalculateVersionList,
                data: {},
                dataType: 'json',
                doneResult: res => {
                    this.setState({ 
                        versionList: res.datas || [],
                    }, () => {
                        resolve(res.datas.length > 0 ? res.datas[0].empCostBasicParameterVersionId : undefined);
                    });
                },
                errorResult: () => {
                    resolve(undefined);
                }
            };
            $.sendRequest(options);
        });
    }
    //  窗口期 下拉数据
    queryWindowList = () => {
        return new Promise((resolve) => {
            const options = {
                method: 'POST',
                url: API_URL.evaluate.queryWindowList,
                data: {},
                dataType: 'json',
                doneResult: res => {
                    this.setState({ 
                        windowList: res.datas || [],
                    }, () => {
                        resolve(res.datas.length > 0 ? res.datas[0].empCostTimeWindowId : undefined);
                    });
                },
                errorResult: () => {
                    resolve(undefined);
                }
            };
            $.sendRequest(options);
        });
    }

    initSearchParams = () => {
        Promise.all([this.queryHavCalculateVersionList(), this.queryWindowList()]).then(([versionId, windowId]) => {
            this.setState({
                searchParams: {
                    empCostBasicParameterVersionId: versionId,
                    empCostTimeWindowId: windowId,
                },
            }, () => {
                this.loadData();
            });
        });
    }
    
    loadData = () => {
        const { searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        const { researchProductTypeId = [] } = searchParams;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryUnitPriceList,
            data: {
                offset: current,
                limit: pageSize,
                ...searchParams,
                researchProductTypeId: researchProductTypeId[researchProductTypeId.length - 1],
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                const oldList = [];
                pagination.total = totalCount;
                (datas || []).map(el => {
                    oldList.push({
                        oldPrice: el.manualUnitPrice,
                    })
                });
                this.setState({
                    loading: false,
                    data: datas,
                    oldData: oldList,  //储存原始数据，用于编辑撤销操作
                    pagination,
                });
            }
        };
        $.sendRequest(options);
    };

    //获取业务线选项
    queryBusiness = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => this.setState({ businessList: res.typeConfigureList || [] }));
    }

    //获取项目领域选项
    loadTypeConfigureList = () => {
        dictCache.getDict('TYPE_CONFIGURE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.typeConfigureList,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({
                areaList: res.areaList,
            });
        });
    }

    //研究产品类型选项
    queryConfigWithChildByType = () => {
        dictCache.getDict('CONFIG_WITH_CHILD_RESEARCH_PRODUCT_TYPE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.evaluate.queryConfigWithChildByType,
                data: { type: 'RESEARCH_PRODUCT_TYPE' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { list = [] } = res;
            const newList = list.map(el => ({
                value: el.evaluateConfigureId,
                code: el.code,
                label: el.configureValue,
                children: el.childList.length ? el.childList.map(childData => ({
                    value: childData.evaluateConfigureId,
                    label: childData.configureValue,
                })) : undefined,
            }));
            this.setState({ researchProductTypeList: newList });
        });
    }

    search = () => {
        const { pagination = {} } = this.state;
        pagination.current = 1;
        this.setState({ pagination },
            () => {
                this.loadData();
            }
        );
    };

    queryNewestDate = () => {
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryNewestDate,
            data: { type: 'EVALUATE_STANDARD_VISIT_UNIT_PRICE' },
            dataType: 'json',
            doneResult: res => {
                this.setState({ refreshTime: res.data });
            }
        };
        $.sendRequest(options);
    }

    handleTabsChange = (activeKey) => {
        this.setState({ activeKey }, () => {
            this.updatePanes();
        });
    }

    exportData = () => {
        const { searchParams } = this.state;
        const { researchProductTypeId = [] } = searchParams;
        const url = API_URL.evaluate.exportUnitPriceList;
        ExportUtil.export({
            ...searchParams,
            researchProductTypeId: researchProductTypeId[researchProductTypeId.length - 1],
        }, null, url);
    }

    exportCureData = () => {
        this.ExportCureDataRef.show();
    }

    refresh = () => {
        const { refreshLoading } = this.state;
        if(refreshLoading) {
            return message.warning('任务未处理完成，请稍后再试！')
        }
        this.setState({ refreshLoading: true });
        const options = {
            method: 'POST',
            url: API_URL.evaluate.initStandardVisitUnitPrice,
            data: {},
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ refreshLoading: false });
                this.loadData();
                this.queryNewestDate();
            }
        };
        $.sendRequest(options);
    }

    getColumns = () => {
        const columns = [{
            title: '序号',
            dataIndex: 'sortNum',
            key: 'sortNum',
            width: 80,
        },
        {
            title: '业务线',
            dataIndex: 'lineOfBusinessString',
            key: 'lineOfBusinessString',
            width: 100,
        },
        {
            title: '研究产品类型',
            dataIndex: 'researchProductTypeName',
            key: 'researchProductTypeName',
            width: 120,
        },
        {
            title: '项目领域',
            dataIndex: 'investigationAreaName',
            key: 'investigationAreaName',
            width: 160,
        },
        {
            title: '疾病分类',
            dataIndex: 'diseaseClassName',
            key: 'diseaseClassName',
            width: 100,
        },
        {
            title: '疾病',
            dataIndex: 'diseaseName',
            key: 'diseaseName',
            width: 100,
        },
        {
            title: '标准访视单价（合同额不含税/合同标准访视数）',
            dataIndex: 'originalUnitPrice',
            key: 'originalUnitPrice',
            width: 160,
            render: text => text ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '-'
        },
        {
            title: '参与计算的项目数量',
            dataIndex: 'invNum',
            key: 'invNum',
            width: 100,
        },
        {
            title: '入组数/中心数',
            dataIndex: 'planRandomSiteRate',
            key: 'planRandomSiteRate',
            width: 120,
        },
        {
            title: '单位FTE标准访视数',
            dataIndex: 'visitRatioFte',
            key: 'visitRatioFte',
            width: 120,
        },
        {
            title: 'FTE单价',
            dataIndex: 'fteEmpCostAmount',
            key: 'fteEmpCostAmount',
            width: 100,
            render: text => text ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '-'
        },
        {
            title: '标访单价',
            dataIndex: 'visitEmpCostAmount',
            key: 'visitEmpCostAmount',
            width: 100,
            render: text => text ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '-'
        },
            // {
            //     title: '标准访视单价（FIN）/不含税',
            //     dataIndex: 'manualUnitPrice',
            //     key: 'manualUnitPrice',
            //     width: 160,
            //     render: (text, record, index) => {
            //         const { isEdit = false, markRed = false } = record;
            //         return isEdit ? <div style={{display: 'flex', alignItems: 'center'}}>
            //             <InputNumber
            //                 min={0}
            //                 precision={2}
            //                 step={0.01}
            //                 placeholder='请输入'
            //                 style={{ width: 140 }}
            //                 formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            //                 value={text}
            //                 onChange={value => this.handleChange(value, index, 'manualUnitPrice')}
            //             />
            //         </div> : (text ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '')    //千分位
            //     }
            // }, 
            // {
            //     title: '操作',
            //     dataIndex: 'operate',
            //     key: 'operate',
            //     width: 120,
            //     render: (text, record, index) => {
            //         const { isEdit = false } = record;
            //         const { curRole } = sessionStorage;
            //         return (curRole == 'FIN' || curRole == 'VP' || curRole == 'BO') ? <div>
            //             { isEdit ? <span>
            //                         <a onClick={() => this.save(record)}>保存</a>
            //                         <span className="ant-divider" />
            //                         <a onClick={() => this.handleEditChange(false, index)}>返回</a>
            //                     </span>
            //                     : <a onClick={() => this.handleEditChange(true, index)}>修改</a>
            //             }
            //         </div>
            //         : '-'
            //     }
            // }
        ];
        return columns;
    }

    save = (record) => {
        const { id, manualUnitPrice, evaluateStandardVisitUnitPriceId } = record;
        if (manualUnitPrice !== 0 && !manualUnitPrice) {
            return message.warning('请输入标准访视单价（FIN）')
        }
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.evaluate.saveStandardVisitUnitPrice,
            data: {
                id,
                manualUnitPrice,
                evaluateStandardVisitUnitPriceId,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.loadData();
            }
        };
        $.sendRequest(options);
    }

    handleChange = (value, index, key) => {
        const { data } = this.state;
        data[index][key] = value;
        this.setState({ data });
    }

    handleEditChange = (value, index) => {
        const { data, oldData } = this.state;
        data[index].isEdit = value;
        if (!value) {
            data[index].manualUnitPrice = oldData[index].oldPrice;
        }
        this.setState({ data });
    }

    handleTableChange = (pagination) => {
        this.setState({
            pagination,
        }, () => {
            this.loadData();
        });
    }

    handleFilterChange = (value, key) => {
        const { searchParams } = this.state;
        searchParams[key] = value;
        this.setState({ searchParams });
    }

    getDataSource = () => {
        const { data, pagination } = this.state;
        const dataSource = [];
        data.map((el, index) => {
            dataSource.push({
                ...el,
                sortNum: (pagination.current - 1) * 10 + index + 1,
            });
        });
        return dataSource
    }

    handleCalculate = () => {
        this.CalculateModalRef.show();
    }
    handleSetting = () => {
        this.SettingModalRef.show();
    }

    render() {
        const { refreshTime, loading, pagination, searchParams, businessList, areaList, versionList, windowList, researchProductTypeList } = this.state;
        const { curRole } = sessionStorage;
        return (
            <div className="content">
                <SideNav selectKey="price" />
                <div className="main">
                    <div style={{ marginBottom: 10, width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                        <span onClick={() => this.refresh()} style={{ cursor: 'pointer', marginRight: 10 }}>
                            <Icon type="sync" style={{ fontSize: 14, fontWeight: 'bold', color: '#4ec990' }} />
                        </span>
                        {refreshTime}
                    </div>
                    <Filter
                        params={searchParams}
                        onChange={this.handleFilterChange}
                        onFocus={this.queryHavCalculateVersionList}
                        search={this.search}
                        exportData={this.exportData}
                        exportCureData={this.exportCureData}
                        businessList={businessList}
                        areaList={areaList}
                        versionList={versionList}
                        windowList={windowList}
                        researchProductTypeList={researchProductTypeList}
                    />
                    <div style={{ color: 'red', margin: '0 0 15px 5px' }}>
                        项目阶段不包含：项目终止、项目暂停、项目待终止、服务合同签署前终止；<br />
                        执行业务线二级分类包含：启动后常规CRC执行、启动前协助+启动后常规CRC执行；<br />
                        项目分期不包含：IV期、研究者发起研究、上市后、观察性研究、真实性研究、流调、其他；<br />
                        项目要求：取 202401～202512 确认 FTE /确认标访数有值的项目；<br />
                        合同要求：合同的“合同是否标明合同金额”为是、合同的“计收入确认方式”为所有计收入确认方式。<br />
                    </div>
                    {
                        curRole == 'FIN' &&
                        <div style={{ marginBottom: 10 }}>
                            <Button type="primary" onClick={this.handleCalculate}>计算基础</Button>
                            <Button type="primary" style={{ marginLeft: 10 }} onClick={this.handleSetting}>参数设置</Button>
                        </div>
                    }
                    <Table
                        dataSource={this.getDataSource()}
                        bordered
                        loading={loading}
                        columns={this.getColumns()}
                        pagination={pagination}
                        onChange={this.handleTableChange}
                        scroll={{ x: 500 }}
                    />
                    <ExportCureData ref={el => this.ExportCureDataRef = el} />
                    <CalculateModal ref={el => this.CalculateModalRef = el}  resetData={this.resetData}/>
                    <SettingModal ref={el => this.SettingModalRef = el} resetData={this.resetData}/>
                </div>
            </div>
        );
    }
}


export default StandardVisitPrice



// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/standardVisitPrice/index.js